export default "__VITE_ASSET__DUd9NsH5__"